// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pNYY","comment":"styles_comment__1gyEr"};